import React, { useEffect, useState } from "react";
import { useLocation } from "@reach/router";
import { isAndroid, isDesktop, isIOS, isTablet } from "react-device-detect";
import { replaceByDict } from "../utilities/replace-by-dict";
import useQueryParams from "query-params-hook";
import { graphql, useStaticQuery } from "gatsby";

const AdjustLink = ({
  externalUrl,
  topMenu,
  slotPage,
  children,
  className,
  menuUrl,
  target,
}: {
  externalUrl?: string;
  topMenu?: boolean;
  slotPage?: boolean;
  className?: string;
  children: any;
  menuUrl?: string;
  target?: string;
}) => {
  const { pathname } = useLocation();
  const {
    lp: lpPages,
    campaignid,
    adgroupid,
    keyword,
    adid,
    lpurl,
    gclid,
  } = useQueryParams();
  const isLpPage = lpPages === "true";

  const data = useStaticQuery(graphql`
    query {
      allContentfulComposePage {
        nodes {
          slug
          adjustLink {
            adjustLink
          }
        }
      }
    }
  `) as any;

  const adjustLinkData = data.allContentfulComposePage.nodes.find(
    (node: any) => `/${node.slug}/` === pathname
  );
  const adjustLink = adjustLinkData?.adjustLink?.adjustLink;

  if (isDesktop) return children;

  const [link, setLink] = useState("");

  useEffect(() => {
    // specific case for /blog/...
    if (pathname.includes("/blog")) {
      setLink("https://jackpotparty.go.link?adj_t=1fwi00co_1fpdipro_1fohsk1v");
      return;
    }
    if (adjustLink) {
      setLink(adjustLink);
      return;
    }
    if (!!externalUrl) {
      const replaceHashed = {
        campaignid,
        adgroupid,
        keyword,
        adid,
        lpurl,
        gclid,
      };
      setLink(replaceByDict(externalUrl, replaceHashed));
      return;
    }
    if (lpPages === "true") {
      const replaceHashed = {
        campaignid,
        adgroupid,
        keyword,
        adid,
        lpurl,
        gclid,
      };
      setLink(
        replaceByDict(
          "https://app.adjust.com/zuoayv2_imr1p88?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}",
          replaceHashed
        )
      );
      return;
    }
    if (topMenu && pathname.includes("/blog")) {
      setLink("https://app.adjust.com/67lpxp7_3k0r255_v3zmbmm");
    } else if (topMenu) {
      setLink(menuUrl ?? "https://app.adjust.com/p0m9e6u_axx4qia_ygfkr74");
    } else if (slotPage) {
      setLink("https://app.adjust.com/4j0a3j4_b9tpa2j_cxz6pvi");
    } else {
      // Hero Link per pathname
      if (pathname === "/") {
        if (isIOS && isTablet) {
          setLink("https://app.adjust.com/69lf5i0_rjwfk4i_vr3ktty");
        } else {
          setLink("https://app.adjust.com/rjwfk4i_69lf5i0_vr3ktty");
        }
      } else if (pathname.includes("/mobile-slots")) {
        if (isIOS && isTablet) {
          setLink("https://app.adjust.com/6gdfuli_l16rniu_96lz90w");
        } else {
          setLink("https://app.adjust.com/l16rniu_6gdfuli_96lz90w");
        }
      } else if (pathname.includes("/free-coins")) {
        if (isIOS && isTablet) {
          setLink("https://app.adjust.com/e28wryg_2l9k5i0_n0zgeae");
        } else {
          setLink("https://app.adjust.com/2l9k5q2_e28wryg_n0zgeae");
        }
      } else if (pathname.includes("/slot-games")) {
        if (isIOS && isTablet) {
          setLink("https://app.adjust.com/pgxvdd9");
        } else {
          setLink("https://app.adjust.com/pgxvdd9_caxlvm7_cy2k7cn");
        }
      } else {
        setLink(
          isAndroid
            ? "https://app.adjust.com/113z4xk4"
            : "https://app.adjust.com/11uy0jlw"
        );
      }
    }
  }, [
    adjustLink,
    pathname,
    externalUrl,
    lpPages,
    campaignid,
    adgroupid,
    keyword,
    adid,
    lpurl,
    gclid,
    topMenu,
    slotPage,
    menuUrl,
    adjustLink,
  ]);

  return (
    <a
      href={link}
      className={className}
      onClick={() => isLpPage && (window as any).gtag_report_conversion?.()}
      target={target}
    >
      {children}
    </a>
  );
};

export default AdjustLink;
